import angular from 'angular';
import controller from './get-started-form.controller';
import template from './get-started-form.jade';

export default function directive() {
  return {
    restrict: 'E',
    transclude: true,
    scope: true,
    bindToController: {
      prev: '@',
      next: '@',
      onSubmit: '&',
      model: '=',
      submitting: '=',
    },
    controllerAs: 'getStartedForm',
    controller,
    template,
    link,
  };
}

function link(scope, element, attrs, ctrl, transcludeFn) {
  const el = element.find('get-started-form-fields');

  // Manually trancluding here so that we keep the same scope
  // so we have access to the parent `form`
  transcludeFn(scope, function(clone) {
    angular.element(el[0]).append(clone);
  });
}
